module.exports = __webpack_public_path__ + "img/fouling-overview-widget-illustration.17f9345c.png";